import React, { useContext } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from "@material-ui/core";
import FeedbacksContext from "../contexts/FeedbacksContext";
import { brand, serif } from '../theme';

const useStyles = makeStyles((theme) => ({
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    borderTop: `1px solid ${brand.ink}`,
  },
  item: {
    margin: 0,
    padding: theme.spacing(4, 0),
    borderBottom: `1px solid ${brand.line}`,
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3, 0),
    },
  },
  quote: {
    fontFamily: serif,
    fontSize: '1.35rem',
    lineHeight: 1.45,
    margin: 0,
    whiteSpace: 'pre-line',
    overflowWrap: 'anywhere',
    '&::before': {
      content: '"\\201C"',
      color: brand.accent,
      marginRight: 2,
    },
    '&::after': {
      content: '"\\201D"',
      color: brand.accent,
      marginLeft: 2,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.15rem',
    },
  },
  author: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
    '&::before': {
      content: '""',
      width: 24,
      height: 1,
      backgroundColor: brand.accent,
      marginRight: 12,
    },
  },
  empty: {
    padding: theme.spacing(4, 0),
    borderTop: `1px solid ${brand.ink}`,
    color: theme.palette.text.secondary,
  },
}));

export default function FeedbacksList() {
  const classes = useStyles();
  const feedbacksContext = useContext(FeedbacksContext);
  const { feedbacks } = feedbacksContext;
  const visible = feedbacks.filter((item) => item.show);

  if (visible.length === 0) {
    return (
      <Typography className={classes.empty}>
        Be one of the first to share your experience with us.
      </Typography>
    );
  }

  return (
    <ul className={classes.list}>
      {visible.map((value, index) => (
        <li key={value.id || index}>
          <figure className={classes.item}>
            <blockquote className={classes.quote}>{value.feedback}</blockquote>
            <Typography variant="overline" component="figcaption" className={classes.author}>
              {value.feedbackName}
            </Typography>
          </figure>
        </li>
      ))}
    </ul>
  );
}
